<template>
  <BlocoFormularioCadastro voltar="/guia" @salvar="salvar()">
    <template #toolbar>
      <button
        v-if="guia._id"
        data-test-id="button-exportarguia-1"
        typ="button"
        class="btn btn-info"
        @click.prevent="exportarGuia()"
        ><span class="fa fa-file" /> Imprimir</button
      >
      <button
        data-test-id="button-visaosimplificada-visaosimplificada-2"
        class="btn btn-primary"
        @click.prevent="visaoSimplificada = !visaoSimplificada"
        ><span class="fa fa-eye" /> Visão simplificada</button
      >
    </template>
    <template #form>
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <div
            :class="{ 'has-error': v$.guia.unidade.$error }"
            class="input-group"
          >
            <span class="input-group-addon">Unidade <sup>(1)</sup></span>
            <select
              id="unidade"
              v-model="guia.unidade"
              data-test-id="select-unidade"
              class="form-control"
            >
              <option
                v-for="unidade in unidades"
                :key="unidade._id"
                :value="unidade"
                >{{ unidade.nome }}</option
              >
            </select>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <div
            :class="{ 'has-error': v$.guia.especialidade.$error }"
            class="input-group"
          >
            <span class="input-group-addon">Especialidade <sup>(1)</sup></span>
            <select
              id="especialidade"
              v-model="guia.especialidade"
              data-test-id="select-especialidade"
              class="form-control"
              @change="selecionarEspecialidade"
            >
              <option
                v-for="especialidade in especialidades"
                :key="especialidade.nome"
                :value="especialidade.nome"
                >{{ especialidade.nome }}</option
              >
            </select>
          </div>
        </div>
      </div>
      <br />
      <div
        :class="v$.guia.autorizacao.$error ? 'panel-danger' : 'panel-primary'"
        class="panel"
      >
        <div
          v-if="!visaoSimplificada"
          id="headingAutorizacao"
          class="panel-heading"
        >
          <h4 class="panel-title"> Autorização </h4>
        </div>
        <div class="panel-body">
          <DadosAutorizacao
            :guia="guia"
            :validations="v$"
            :visao-simplificada="visaoSimplificada"
          />
        </div>
      </div>
      <div
        :class="v$.guia.beneficiario.$error ? 'panel-danger' : 'panel-primary'"
        class="panel"
      >
        <div
          v-if="!visaoSimplificada"
          id="headingBeneficiario"
          class="panel-heading"
        >
          <h4 class="panel-title"> Beneficiário </h4>
        </div>
        <div class="panel-body">
          <DadosBeneficiario
            :guia="guia"
            :paciente="paciente"
            :validations="v$"
            :visao-simplificada="visaoSimplificada"
            @selecionarPaciente="selecionarPaciente"
            @limparPaciente="limparPaciente()"
          />
        </div>
      </div>
      <div
        :class="
          v$.guia.contratadoSolicitante.$error
            ? 'panel-danger'
            : 'panel-primary'
        "
        class="panel"
      >
        <div
          v-if="!visaoSimplificada"
          id="headingSolicitante"
          class="panel-heading"
        >
          <h4 class="panel-title"> Contratado solicitante </h4>
        </div>
        <div class="panel-body">
          <DadosContratadoSolicitante
            :guia="guia"
            :validations="v$"
            :visao-simplificada="visaoSimplificada"
          />
        </div>
      </div>
      <div
        :class="v$.guia.solicitacao.$error ? 'panel-danger' : 'panel-primary'"
        class="panel"
      >
        <div
          v-if="!visaoSimplificada"
          id="headingSolicitacao"
          class="panel-heading"
        >
          <h4 class="panel-title">
            Solicitação / Procedimentos / Exames solicitados
          </h4>
        </div>
        <div class="panel-body">
          <DadosSolicitacao
            :guia="guia"
            :validations="v$"
            :visao-simplificada="visaoSimplificada"
            @selecionadoProcedimento="selecionadoProcedimento"
            @limparProcedimento="limparProcedimento"
            @alterouTabela="alterouTabela"
          />
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        :class="
          v$.guia.contratadoExecutante.$error ? 'panel-danger' : 'panel-primary'
        "
        class="panel"
      >
        <div id="headingExecutante" class="panel-heading">
          <h4 class="panel-title"> Contratado executante </h4>
        </div>
        <div class="panel-body">
          <DadosContratadoExecutante
            :guia="guia"
            :visao-simplificada="visaoSimplificada"
            :validations="v$"
          />
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        :class="v$.guia.atendimento.$error ? 'panel-danger' : 'panel-primary'"
        class="panel"
      >
        <div id="headingAtendimento" class="panel-heading">
          <h4 class="panel-title"> Atendimento </h4>
        </div>
        <div class="panel-body">
          <DadosAtendimento
            :guia="guia"
            :visao-simplificada="visaoSimplificada"
            :validations="v$"
          />
        </div>
      </div>
      <div v-if="!visaoSimplificada" class="panel panel-primary">
        <div id="headingConsulta" class="panel-heading">
          <h4 class="panel-title"> Consulta de referência </h4>
        </div>
        <div class="panel-body">
          <ConsultaReferencia
            :guia="guia"
            :visao-simplificada="visaoSimplificada"
          />
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        :class="
          v$.guia.procedimentosRealizados.$error
            ? 'panel-danger'
            : 'panel-primary'
        "
        class="panel"
      >
        <div id="headingRealizados" class="panel-heading">
          <h4 class="panel-title"> Procedimentos e exames realizados </h4>
        </div>
        <div class="panel-body">
          <ProcedimentosRealizados
            :guia="guia"
            :validations="v$"
            :visao-simplificada="visaoSimplificada"
            @recalcular="recalcularGuia"
          />
        </div>
      </div>
      <p>(1) Campos obrigatórios </p>
      <p
        >(2) Nome do profissional solicitante é obrigatório quando o contratado
        é Pessoa Jurídica.</p
      >
      <p
        >(3) Campos obrigatórios quando os campos 30/31 forem pessoa física ou
        quando os campos 40a/41 forem preenchidos.</p
      >
      <p
        >(4) Registro ANS preenchido automaticamente ao selecionar o convênio do
        beneficiário.</p
      >
      <p>(5) Número da Guia gerado automaticamente após salvar a guia.</p>
      <p>(6) Informação destinada ao faturamento da guia.</p>
      <p
        >(7) A carteira do plano deve ter validade superior ou pelo menos igual
        ao dia de hoje.</p
      >
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {
  maxLength,
  minLength,
  minValue,
  required,
  requiredIf,
} from '@vuelidate/validators'
import moment from 'moment'
import numeral from 'numeral'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import { useMenu } from '@/composables/useMenu'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import CepServico from '@/servicos/CepServico'
import ConvenioServico from '@/servicos/ConvenioServico'
import EspecialidadeServico from '@/servicos/EspecialidadeServico'
import GuiaServico from '@/servicos/GuiaServico'
import MensagemServico from '@/servicos/MensagemServico'
import PacienteServico from '@/servicos/PacienteServico'
import ProfissionalServico from '@/servicos/ProfissionalServico'
import UnidadeServico from '@/servicos/UnidadeServico'
import appStore from '@/stores'

import ConsultaReferencia from './ConsultaReferencia'
import DadosAtendimento from './DadosAtendimento'
import DadosAutorizacao from './DadosAutorizacao'
import DadosBeneficiario from './DadosBeneficiario'
import DadosContratadoExecutante from './DadosContratadoExecutante'
import DadosContratadoSolicitante from './DadosContratadoSolicitante'
import DadosSolicitacao from './DadosSolicitacao'
import ProcedimentosRealizados from './ProcedimentosRealizados'

const especialidadeServico = new EspecialidadeServico()
const agendamentoServico = new AgendamentoServico()
const pacienteServico = new PacienteServico()
const profissionalServico = new ProfissionalServico()
const unidadeServico = new UnidadeServico()
const guiaServico = new GuiaServico()
const mensagemServico = new MensagemServico()
const convenioServico = new ConvenioServico()
const cepServico = new CepServico()
const hoje = moment().format('DD/MM/YYYY')

export default {
  components: {
    BlocoFormularioCadastro,
    DadosAutorizacao,
    DadosBeneficiario,
    DadosContratadoSolicitante,
    DadosSolicitacao,
    DadosContratadoExecutante,
    DadosAtendimento,
    ConsultaReferencia,
    ProcedimentosRealizados,
  },

  setup() {
    useMenu(20)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      visaoSimplificada: false,
      totalProcedimentos: 0,
      unidades: [],
      especialidades: [],
      maxAgendamentosEspecialidade: 0,
      paciente: {},
      guia: {
        agendamento: [],
        paciente: {},
        profissional: {},
        unidade: '',
        especialidade: '',
        pacienteGestante: '',
        autorizacao: {
          registroANS: '',
          numeroGuia: '',
          numeroGuiaPrincipal: '',
          dataAutorizacao: '',
          senha: '',
          validadeSenha: '',
          dataEmissao: '',
        },
        beneficiario: {
          _id: '',
          nome: '',
          plano: '',
          numeroCarteira: '',
          validadeCarteira: '',
          numeroCartaoNacionalSaude: '',
          convenio: {},
          coParticipacao: false,
        },
        contratadoSolicitante: {
          tipoSolicitante: 'J',
          documentoSolicitante: '',
          nome: '',
          cnes: '',
          profissionalSolicitante: {
            _id: '',
            nome: '',
            conselho: '',
            numeroConselho: '',
            ufConselho: '',
            cbo: {},
          },
        },
        solicitacao: {
          data: '',
          hora: '',
          carater: '',
          cid10: '',
          indicacao: '',
          procedimentos: [
            {
              data: hoje,
              codTabela: '',
              codigo: '',
              nome: '',
              valorFixo: '',
              qtdRealizada: 0,
              qtdSolicitada: '',
              qtdAutorizada: '',
              vazio: false,
            },
            {
              data: hoje,
              codTabela: '',
              codigo: '',
              nome: '',
              valorFixo: '',
              qtdRealizada: 0,
              qtdSolicitada: '',
              qtdAutorizada: '',
              vazio: true,
            },
            {
              data: hoje,
              codTabela: '',
              codigo: '',
              nome: '',
              valorFixo: '',
              qtdRealizada: 0,
              qtdSolicitada: '',
              qtdAutorizada: '',
              vazio: true,
            },
            {
              data: hoje,
              codTabela: '',
              codigo: '',
              nome: '',
              valorFixo: '',
              qtdRealizada: 0,
              qtdSolicitada: '',
              qtdAutorizada: '',
              vazio: true,
            },
            {
              data: hoje,
              codTabela: '',
              codigo: '',
              nome: '',
              valorFixo: '',
              qtdRealizada: 0,
              qtdSolicitada: '',
              qtdAutorizada: '',
              vazio: true,
            },
          ],
        },
        contratadoExecutante: {
          tipoExecutante: 'J',
          documentoExecutante: '',
          nome: '',
          endereco: {
            tipoLogradouro: '',
            logradouro: '',
            numero: '',
            complemento: '',
            municipio: '',
            uf: '',
            codigoIBGEMunicipio: '',
            cep: '',
          },
          cnes: '',
          tipoComplementar: 'J',
          documentoComplementar: '',
          nomeComplementar: '',
          conselho: '',
          conselhoNumero: '',
          conselhoUF: '',
          cbo: '',
          grauParticipacao: '',
        },
        atendimento: {
          tipoAtendimento: '',
          indicacaoAcidente: '',
          tipoSaida: '',
        },
        consultaReferencia: {
          tipoDoenca: '',
          tempoDoenca: {
            anos: '',
            meses: '',
            dias: '',
          },
        },
        procedimentosRealizados: {
          procedimentos: [
            {
              data: hoje,
              horaInicial: '',
              horaFinal: '',
              codigoTabela: '',
              codigo: '',
              nome: '',
              qtdRealizada: '',
              qtdSolicitada: 0,
              qtdAutorizada: 0,
              viaAcesso: '',
              tecnicaUtilizada: '',
              reducaoAcrescimoPct: '',
              valorUnitario: '',
              valorTotal: '',
              valorFixo: '',
              vazio: false,
            },
            {
              data: hoje,
              horaInicial: '',
              horaFinal: '',
              codigoTabela: '',
              codigo: '',
              nome: '',
              qtdRealizada: '',
              qtdSolicitada: 0,
              qtdAutorizada: 0,
              viaAcesso: '',
              tecnicaUtilizada: '',
              reducaoAcrescimoPct: '',
              valorUnitario: '',
              valorTotal: '',
              valorFixo: '',
              vazio: true,
            },
            {
              data: hoje,
              horaInicial: '',
              horaFinal: '',
              codigoTabela: '',
              codigo: '',
              nome: '',
              qtdRealizada: '',
              qtdSolicitada: 0,
              qtdAutorizada: 0,
              viaAcesso: '',
              tecnicaUtilizada: '',
              reducaoAcrescimoPct: '',
              valorUnitario: '',
              valorTotal: '',
              valorFixo: '',
              vazio: true,
            },
            {
              data: hoje,
              horaInicial: '',
              horaFinal: '',
              codigoTabela: '',
              codigo: '',
              nome: '',
              qtdRealizada: '',
              qtdSolicitada: 0,
              qtdAutorizada: 0,
              viaAcesso: '',
              tecnicaUtilizada: '',
              reducaoAcrescimoPct: '',
              valorUnitario: '',
              valorTotal: '',
              valorFixo: '',
              vazio: true,
            },
            {
              data: hoje,
              horaInicial: '',
              horaFinal: '',
              codigoTabela: '',
              codigo: '',
              nome: '',
              qtdRealizada: '',
              qtdSolicitada: 0,
              qtdAutorizada: 0,
              viaAcesso: '',
              tecnicaUtilizada: '',
              reducaoAcrescimoPct: '',
              valorUnitario: '',
              valorTotal: '',
              valorFixo: '',
              vazio: true,
            },
          ],
          observacao: '',
          totalProcedimentos: '',
          totalTaxasAlugueis: '',
          totalMateriais: '',
          totalMedicamentos: '',
          totalDiarias: '',
          totalGases: '',
          totalGuia: '',
          fixarValor: false,
          fatorMultiplicador: 1,
        },
        opm: {
          solicitados: [],
          utilizados: [],
        },
      },
    }
  },
  computed: {
    totalGeralGuia() {
      let soma = 0
      soma += numeral(
        this.guia.procedimentosRealizados.totalProcedimentos
      ).value()
      soma += numeral(
        this.guia.procedimentosRealizados.totalTaxasAlugueis
      ).value()
      soma += numeral(this.guia.procedimentosRealizados.totalMateriais).value()
      soma += numeral(
        this.guia.procedimentosRealizados.totalMedicamentos
      ).value()
      soma += numeral(this.guia.procedimentosRealizados.totalDiarias).value()
      soma += numeral(this.guia.procedimentosRealizados.totalGases).value()
      return soma
    },
  },
  watch: {
    totalGeralGuia() {
      this.guia.procedimentosRealizados.totalGuia = numeral(
        this.totalGeralGuia
      ).format('0,0.00')
    },
  },
  validations: {
    guia: {
      unidade: { required },
      especialidade: { required },
      pacienteGestante: { required: (val) => val !== '' },
      autorizacao: {
        numeroGuiaPrincipal: { maxLength: maxLength(20) },
        senha: { maxLength: maxLength(20) },
        dataEmissao: { required },
      },
      beneficiario: {
        nome: { required, maxLength: maxLength(70) },
        plano: { required, maxLength: maxLength(40) },
        numeroCarteira: { maxLength: maxLength(20) },
        validadeCarteira: {
          valida(data, beneficiario) {
            const convenio = beneficiario.convenio
            if (data) {
              const flagDataNova =
                data.length === 10 && moment(data, 'DD/MM/YYYY', true).isValid()
              const flagDataDoBanco = data.length > 10

              if (convenio._id) {
                if (convenio.particular) {
                  return true
                }

                if (flagDataDoBanco) {
                  return moment(data).isSameOrAfter(new Date(), 'day')
                }

                if (flagDataNova) {
                  return moment(data, 'DD/MM/YYYY', true).isSameOrAfter(
                    new Date(),
                    'day'
                  )
                }
              }
            }

            return true
          },
        },
        numeroCartaoNacionalSaude: { maxLength: maxLength(15) },
      },
      contratadoSolicitante: {
        documentoSolicitante: { required },
        nome: { required, maxLength: maxLength(70) },
        cnes: { maxLength: maxLength(7) },
        profissionalSolicitante: {
          nome: {
            required: requiredIf(function () {
              return this.guia.contratadoSolicitante.tipoSolicitante === 'J'
            }),
            maxLength: maxLength(70),
          },
          cbo: { required },
          conselho: { required },
          numeroConselho: { required, maxLength: maxLength(15) },
          ufConselho: { required },
        },
      },
      solicitacao: {
        carater: { required },
        cid10: { required, maxLength: maxLength(5) },
        indicacao: { maxLength: maxLength(500) },
        procedimentos: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(5),
          $each: {
            data: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
            },
            codigo: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
            },
            nome: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
            },
            qtdSolicitada: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
              minValue: minValue(1),
            },
            qtdAutorizada: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
              minValue: minValue(1),
            },
            qtdRealizada: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
            },
          },
        },
      },
      contratadoExecutante: {
        nome: { maxLength: maxLength(70) },
        endereco: {
          logradouro: { maxLength: maxLength(40) },
          numero: { maxLength: maxLength(5) },
          complemento: { maxLength: maxLength(15) },
          municipio: { maxLength: maxLength(40) },
          codigoIBGEMunicipio: { maxLength: maxLength(7) },
        },
        cnes: { maxLength: maxLength(7) }, // required quando contratado for hospital
        nomeComplementar: { maxLength: maxLength(70) },
        conselho: {
          required: requiredIf(function () {
            return (
              this.guia.contratadoExecutante.tipoExecutante === 'F' ||
              this.guia.contratadoExecutante.documentoComplementar ||
              this.guia.contratadoExecutante.nomeComplementar
            )
          }),
        },
        conselhoNumero: {
          required: requiredIf(function () {
            return (
              this.guia.contratadoExecutante.tipoExecutante === 'F' ||
              this.guia.contratadoExecutante.documentoComplementar ||
              this.guia.contratadoExecutante.nomeComplementar
            )
          }),
          maxLength: maxLength(15),
        },
        conselhoUF: {
          required: requiredIf(function () {
            return (
              this.guia.contratadoExecutante.tipoExecutante === 'F' ||
              this.guia.contratadoExecutante.numeroDocumentoComplementar ||
              this.guia.contratadoExecutante.nomeComplementar
            )
          }),
        },
        cbo: { maxLength: maxLength(5) },
        grauParticipacao: { maxLength: maxLength(2) }, // required quando procedimento em equipe
      },
      atendimento: {
        tipoAtendimento: { required },
      },
      procedimentosRealizados: {
        procedimentos: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(5),
          $each: {
            data: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
            },
            codigo: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
            },
            nome: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
            },
            qtdSolicitada: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
            },
            qtdAutorizada: {
              required: requiredIf(function (model) {
                return !model.vazio
              }),
            },
          },
        },
      },
      opm: {
        solicitados: {
          $each: {
            codTabela: { maxLength: maxLength(2) },
            codigo: { maxLength: maxLength(10) },
            descricao: { maxLength: maxLength(60) },
            qtd: { maxLength: maxLength(2) },
            fabricante: { maxLength: maxLength(40) },
          },
        },
        utilizados: {
          $each: {
            codTabela: { maxLength: maxLength(2) },
            codigo: { maxLength: maxLength(10) },
            descricao: { maxLength: maxLength(60) },
            qtd: { maxLength: maxLength(2) },
            codBarras: { maxLength: maxLength(20) },
          },
        },
      },
    },
  },
  created() {
    unidadeServico.recuperarTodos().then((result) => {
      this.unidades = result.unidades
      this.inicializaValores()
      if (this.$route.params.id) {
        this.recuperarGuia()
      } else {
        this.recuperarAgendamento()
      }
    })

    especialidadeServico.recuperarTodos({ ativo: true }).then((result) => {
      this.especialidades = result.especialidades
    })
  },
  methods: {
    recalcularGuia(dados) {
      if (this.guia.procedimentosRealizados.fixarValor) {
        this.totalProcedimentos =
          this.procedimentosRealizados.totalProcedimentos
      } else {
        let soma = numeral()

        this.guia.procedimentosRealizados.procedimentos.forEach((p) => {
          if (
            !p.vazio &&
            !/AVALIACAO/i.test(p.nome) &&
            !/AVALIAÇÃO/i.test(p.nome)
          ) {
            const vu = numeral(p.valorUnitario)
            soma = soma.add(vu.value())
          }
        })

        const fm = numeral(this.guia.procedimentosRealizados.fatorMultiplicador)
        this.totalProcedimentos = soma.multiply(fm.value())
      }

      this.guia.procedimentosRealizados.totalProcedimentos = numeral(
        this.totalProcedimentos
      ).format('0,0.00')
    },
    exportarGuia() {
      guiaServico.exportarGuia(this.guia._id).then((r) => {
        const blob = new Blob([r], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url)
      })
    },
    alterouTabela(dados) {
      const codigoTabela = dados.procedimento.codigoTabela

      this.guia.solicitacao.procedimentos.forEach((p) => {
        p.codigoTabela = codigoTabela
      })

      this.guia.procedimentosRealizados.procedimentos.forEach((p) => {
        p.codigoTabela = codigoTabela
      })
    },
    limparProcedimento(dados) {
      const procedimento = this.guia.solicitacao.procedimentos[dados.index]
      procedimento.nome = ''
      procedimento.codigo = ''
      procedimento.codigoNome = ''
      procedimento.valorFixo = ''
      procedimento._id = ''
      procedimento.vazio = true
    },
    selecionarPaciente(paciente) {
      paciente.convenios.forEach((c) => {
        convenioServico.recuperar(c._id).then((res) => {
          c.ans = res.convenio.ans
          c.particular = res.convenio.particular
          c.valorCH = res.convenio.valorCH
          c.tabelas = res.convenio.tabelas
        })
      })
      this.paciente = paciente
      this.guia.beneficiario._id = paciente._id
      this.guia.beneficiario.nome = paciente.nome
    },
    limparPaciente() {
      this.paciente = {}
      this.guia.beneficiario.convenio = {}
      this.guia.beneficiario._id = ''
      this.guia.beneficiario.nome = ''
      this.guia.beneficiario.plano = ''
      this.guia.beneficiario.numeroCarteira = ''
      this.guia.beneficiario.validadeCarteira = ''
      this.guia.beneficiario.numeroCartaoNacionalSaude = ''
      this.guia.autorizacao.registroANS = ''
      this.guia.solicitacao.procedimentos = [
        {
          data: hoje,
          codTabela: '',
          codigo: '',
          nome: '',
          valorFixo: '',
          qtdRealizada: 0,
          qtdSolicitada: '',
          qtdAutorizada: '',
          vazio: false,
        },
        {
          data: hoje,
          codTabela: '',
          codigo: '',
          nome: '',
          valorFixo: '',
          qtdRealizada: 0,
          qtdSolicitada: '',
          qtdAutorizada: '',
          vazio: true,
        },
        {
          data: hoje,
          codTabela: '',
          codigo: '',
          nome: '',
          valorFixo: '',
          qtdRealizada: 0,
          qtdSolicitada: '',
          qtdAutorizada: '',
          vazio: true,
        },
        {
          data: hoje,
          codTabela: '',
          codigo: '',
          nome: '',
          valorFixo: '',
          qtdRealizada: 0,
          qtdSolicitada: '',
          qtdAutorizada: '',
          vazio: true,
        },
        {
          data: hoje,
          codTabela: '',
          codigo: '',
          nome: '',
          valorFixo: '',
          qtdRealizada: 0,
          qtdSolicitada: '',
          qtdAutorizada: '',
          vazio: true,
        },
      ]
      this.guia.procedimentosRealizados.procedimentos = [
        {
          data: '',
          horaInicial: '',
          horaFinal: '',
          codigoTabela: '',
          codigo: '',
          nome: '',
          qtdRealizada: '',
          qtdSolicitada: 0,
          qtdAutorizada: 0,
          viaAcesso: '',
          tecnicaUtilizada: '',
          reducaoAcrescimoPct: '',
          valorUnitario: '',
          valorTotal: '',
          valorFixo: '',
          vazio: false,
        },
        {
          data: '',
          horaInicial: '',
          horaFinal: '',
          codigoTabela: '',
          codigo: '',
          nome: '',
          qtdRealizada: '',
          qtdSolicitada: 0,
          qtdAutorizada: 0,
          viaAcesso: '',
          tecnicaUtilizada: '',
          reducaoAcrescimoPct: '',
          valorUnitario: '',
          valorTotal: '',
          valorFixo: '',
          vazio: true,
        },
        {
          data: '',
          horaInicial: '',
          horaFinal: '',
          codigoTabela: '',
          codigo: '',
          nome: '',
          qtdRealizada: '',
          qtdSolicitada: 0,
          qtdAutorizada: 0,
          viaAcesso: '',
          tecnicaUtilizada: '',
          reducaoAcrescimoPct: '',
          valorUnitario: '',
          valorTotal: '',
          valorFixo: '',
          vazio: true,
        },
        {
          data: '',
          horaInicial: '',
          horaFinal: '',
          codigoTabela: '',
          codigo: '',
          nome: '',
          qtdRealizada: '',
          qtdSolicitada: 0,
          qtdAutorizada: 0,
          viaAcesso: '',
          tecnicaUtilizada: '',
          reducaoAcrescimoPct: '',
          valorUnitario: '',
          valorTotal: '',
          valorFixo: '',
          vazio: true,
        },
        {
          data: '',
          horaInicial: '',
          horaFinal: '',
          codigoTabela: '',
          codigo: '',
          nome: '',
          qtdRealizada: '',
          qtdSolicitada: 0,
          qtdAutorizada: 0,
          viaAcesso: '',
          tecnicaUtilizada: '',
          reducaoAcrescimoPct: '',
          valorUnitario: '',
          valorTotal: '',
          valorFixo: '',
          vazio: true,
        },
      ]
    },
    selecionadoProcedimento(dados) {
      const procedimento = this.guia.solicitacao.procedimentos[dados.index]
      const procedimentosRealizados =
        this.guia.procedimentosRealizados.procedimentos
      const procRealizado = procedimentosRealizados[dados.index]
      procedimento.nome = dados.procedimento.nome
      procedimento.codigo = dados.procedimento.codigo
      procedimento.codigoNome = `${dados.procedimento.codigo} - ${dados.procedimento.nome}`
      procedimento._id = dados.procedimento._id
      procedimento.vazio = false
      procedimento.valorFixo = dados.procedimento.valor_fixo
      procedimento.ch = dados.procedimento.ch
      procRealizado.vazio = false
      const vu = procedimento.ch
        ? procedimento.ch * this.guia.beneficiario.convenio.valorCH
        : procedimento.valorFixo
      procRealizado.valorUnitario = numeral(vu).format('0,0.00')

      if (procedimento._id) {
        procRealizado._id = procedimento._id
      }

      if (procedimento.codigoTabela) {
        procRealizado.codigoTabela = procedimento.codigoTabela
      }

      if (procedimento.codigo) {
        procRealizado.codigo = procedimento.codigo
      }

      if (procedimento.codigoNome) {
        procRealizado.codigoNome = procedimento.codigoNome
      }

      if (procedimento.nome) {
        procRealizado.nome = procedimento.nome
      }

      if (procedimento.qtdRealizada) {
        procRealizado.qtdRealizada = procedimento.qtdSolicitada
      }

      if (procedimento.valorFixo) {
        procRealizado.valorFixo = procedimento.valorFixo
      }

      if (procedimento.ch) {
        procRealizado.ch = procedimento.ch
      }
    },
    recuperarSequencia() {
      if (this.guia.unidade.faixa) {
        guiaServico
          .recuperarSequencia({ id: this.guia.unidade.faixa })
          .then((res) => {
            this.guia.autorizacao.numeroGuia = res.seq.seq
          })
      }
    },
    inicializaValores() {
      this.guia.autorizacao.dataEmissao = hoje
      this.guia.contratadoSolicitante.documentoSolicitante = '06277192000164'
      this.guia.contratadoSolicitante.nome = 'CLIN TACTUS FISIOTERAPIA LTDA.'
      this.guia.contratadoSolicitante.cnes = '6603866'
      this.guia.solicitacao.carater = 'E'
      this.guia.atendimento.tipoAtendimento = 3
      this.guia.contratadoExecutante.documentoExecutante = '06277192000164'
      this.guia.contratadoExecutante.nome = 'CLIN TACTUS FISIOTERAPIA LTDA.'
      this.guia.contratadoExecutante.cnes = '6603866'
    },
    recuperarGuia() {
      const id = this.$route.params.id
      guiaServico
        .recuperar(id)
        .then((res) => {
          this.guia = res.guia
          this.maxAgendamentosEspecialidade =
            this.retornarQuantidadeMaxAgendamentos(this.guia.especialidade)
          const dataAutorizacao = this.guia.autorizacao.dataAutorizacao
          const validadeSenha = this.guia.autorizacao.validadeSenha
          const dataEmissao = this.guia.autorizacao.dataEmissao
          const validadeCarteira = this.guia.beneficiario.validadeCarteira
          const dataSolicitacao = this.guia.solicitacao.data
          const totalProcedimentos =
            this.guia.procedimentosRealizados.totalProcedimentos
          const totalTaxasAlugueis =
            this.guia.procedimentosRealizados.totalTaxasAlugueis
          const totalMateriais =
            this.guia.procedimentosRealizados.totalMateriais
          const totalMedicamentos =
            this.guia.procedimentosRealizados.totalMedicamentos
          const totalDiarias = this.guia.procedimentosRealizados.totalDiarias
          const totalGases = this.guia.procedimentosRealizados.totalGases
          const totalGuia = this.guia.procedimentosRealizados.totalGuia

          this.guia.autorizacao.dataAutorizacao =
            moment(dataAutorizacao).format('DD/MM/YYYY')
          this.guia.autorizacao.validadeSenha =
            moment(validadeSenha).format('DD/MM/YYYY')
          this.guia.autorizacao.dataEmissao =
            moment(dataEmissao).format('DD/MM/YYYY')
          this.guia.beneficiario.validadeCarteira =
            moment(validadeCarteira).format('DD/MM/YYYY')
          this.guia.solicitacao.data =
            moment(dataSolicitacao).format('DD/MM/YYYY')
          this.guia.procedimentosRealizados.totalProcedimentos =
            numeral(totalProcedimentos).format('0,0.00')
          this.guia.procedimentosRealizados.totalTaxasAlugueis =
            numeral(totalTaxasAlugueis).format('0,0.00')
          this.guia.procedimentosRealizados.totalMateriais =
            numeral(totalMateriais).format('0,0.00')
          this.guia.procedimentosRealizados.totalMedicamentos =
            numeral(totalMedicamentos).format('0,0.00')
          this.guia.procedimentosRealizados.totalDiarias =
            numeral(totalDiarias).format('0,0.00')
          this.guia.procedimentosRealizados.totalGases =
            numeral(totalGases).format('0,0.00')
          this.guia.procedimentosRealizados.totalGuia =
            numeral(totalGuia).format('0,0.00')

          this.guia.solicitacao.procedimentos.forEach((p) => {
            p.codigoNome = `${p.codigo} - ${p.nome}`
            const data = moment(p.data)
            p.data = data.format('DD/MM/YYYY')
          })

          const qtdSolic = this.guia.solicitacao.procedimentos.length

          for (let i = 5 - qtdSolic; i > 0; i--) {
            this.guia.solicitacao.procedimentos.push({
              data: '',
              codTabela: '',
              codigo: '',
              nome: '',
              valorFixo: '',
              qtdRealizada: '0',
              qtdSolicitada: '',
              qtdAutorizada: '',
              vazio: true,
            })
          }

          this.guia.procedimentosRealizados.procedimentos.forEach((p) => {
            const data = moment(p.data)
            p.data = data.format('DD/MM/YYYY')
            const reducaoAcrescimoPct = numeral(p.reducaoAcrescimoPct)
            p.reducaoAcrescimoPct = reducaoAcrescimoPct.format('0,0.00')
            const valorUnitario = numeral(p.valorUnitario)
            p.valorUnitario = valorUnitario.format('0,0.00')
            const valorTotal = numeral(p.valorTotal)
            p.valorTotal = valorTotal.format('0,0.00')
            const valorFixo = numeral(p.valorFixo)
            p.valorFixo = valorFixo.format('0,0.00')
            p.codigoNome = `${p.codigo} - ${p.nome}`
          })

          const qtdRealizada =
            this.guia.procedimentosRealizados.procedimentos.length

          for (let i = 5 - qtdRealizada; i > 0; i--) {
            this.guia.procedimentosRealizados.procedimentos.push({
              data: '',
              horaInicial: '',
              horaFinal: '',
              codigoTabela: '',
              codigo: '',
              nome: '',
              qtdRealizada: '',
              qtdSolicitada: 0,
              qtdAutorizada: 0,
              viaAcesso: '',
              tecnicaUtilizada: '',
              reducaoAcrescimoPct: '',
              valorUnitario: '',
              valorTotal: '',
              valorFixo: '',
              vazio: true,
            })
          }

          const unidadeNome = this.guia.unidade.nome
          this.guia.unidade = this.unidades.find((u) => u.nome === unidadeNome)

          if (this.guia.beneficiario._id) {
            pacienteServico
              .recuperar(this.guia.beneficiario._id)
              .then((result) => {
                this.paciente = result.paciente

                this.paciente.convenios.forEach((c) => {
                  convenioServico.recuperar(c._id).then((res) => {
                    c.ans = res.convenio.ans
                    c.particular = res.convenio.particular
                    c.valorCH = res.convenio.valorCH
                    c.tabelas = res.convenio.tabelas

                    if (c._id === this.guia.beneficiario.convenio._id) {
                      this.guia.beneficiario.convenio = c
                    }
                  })
                })
              })
          }
        })
        .catch((err) => {
          if (err) {
            mensagemServico.alerta(
              'Guia não encontrada, contate o administrador do sistema.'
            )
          }
        })
    },
    recuperarAgendamento() {
      const agendamentoId = this.$route.params.agendamentoId
      if (agendamentoId) {
        agendamentoServico
          .recuperarAgendamento(agendamentoId)
          .then((result) => {
            this.guia.agendamento.push(result.agendamento)
            const pacienteId = result.agendamento.paciente._id
            this.recuperarPaciente(pacienteId)
            const profissionalId = result.agendamento.profissional._id
            this.recuperarProfissional(profissionalId)
            const unidade = result.agendamento.unidade
            this.recuperarUnidade(unidade)
          })
      }
    },
    recuperarPaciente(pacienteId) {
      pacienteServico.recuperar(pacienteId).then((result) => {
        this.guia.paciente = result.paciente
        this.atribuiPacienteGuia()
      })
    },
    recuperarProfissional(profissionalId) {
      profissionalServico.recuperar(profissionalId).then((result) => {
        this.guia.profissional = result.profissional
      })
    },
    recuperarUnidade(unidade) {
      unidadeServico.recuperarTodos({ nome: unidade }).then((result) => {
        this.guia.unidade = result.unidades[0]
        this.atribuirUnidadeGuia()
      })
    },
    atribuiPacienteGuia() {
      this.guia.beneficiario.nome = this.guia.paciente.nome
      this.guia.beneficiario.plano = this.guia.paciente.dados_convenio.nome
      this.guia.beneficiario.numeroCarteira =
        this.guia.paciente.dados_convenio.matricula
      this.guia.beneficiario.validadeCarteira = moment(
        this.guia.paciente.dados_convenio.validade
      ).format('DD/MM/YYYY')
    },
    atribuirUnidadeGuia() {
      this.guia.contratadoExecutante.documentoExecutante =
        this.guia.unidade.cnpj
      this.guia.contratadoExecutante.nome = this.guia.unidade.nome
      this.guia.contratadoExecutante.endereco.cep =
        this.guia.unidade.endereco.cep
      cepServico
        .cep(this.guia.contratadoExecutante.endereco.cep)
        .then((result) => {
          this.guia.contratadoExecutante.endereco.municipio = result.localidade
          this.guia.contratadoExecutante.endereco.logradouro = result.logradouro
        })
    },
    preSalvar() {
      const dataAutorizacao = this.guia.autorizacao.dataAutorizacao
      const validadeSenha = this.guia.autorizacao.validadeSenha
      const dataEmissao = this.guia.autorizacao.dataEmissao
      const validadeCarteira = this.guia.beneficiario.validadeCarteira
      const dataSolicitacao = this.guia.solicitacao.data
      const totalProcedimentos =
        this.guia.procedimentosRealizados.totalProcedimentos
      const totalTaxasAlugueis =
        this.guia.procedimentosRealizados.totalTaxasAlugueis
      const totalMateriais = this.guia.procedimentosRealizados.totalMateriais
      const totalMedicamentos =
        this.guia.procedimentosRealizados.totalMedicamentos
      const totalDiarias = this.guia.procedimentosRealizados.totalDiarias
      const totalGases = this.guia.procedimentosRealizados.totalGases
      const totalGuia = this.guia.procedimentosRealizados.totalGuia

      this.guia.autorizacao.dataAutorizacao = dataAutorizacao
        ? moment(dataAutorizacao, 'DD/MM/YYYY').toISOString()
        : ''
      this.guia.autorizacao.validadeSenha = validadeSenha
        ? moment(validadeSenha, 'DD/MM/YYYY').toISOString()
        : ''
      this.guia.autorizacao.dataEmissao = dataEmissao
        ? moment(dataEmissao, 'DD/MM/YYYY').toISOString()
        : ''
      this.guia.beneficiario.validadeCarteira = validadeCarteira
        ? moment(validadeCarteira, 'DD/MM/YYYY').toISOString()
        : ''
      this.guia.solicitacao.data = dataSolicitacao
        ? moment(dataSolicitacao, 'DD/MM/YYYY').toISOString()
        : ''
      this.guia.procedimentosRealizados.totalProcedimentos =
        numeral(totalProcedimentos).value()
      this.guia.procedimentosRealizados.totalTaxasAlugueis =
        numeral(totalTaxasAlugueis).value()
      this.guia.procedimentosRealizados.totalMateriais =
        numeral(totalMateriais).value()
      this.guia.procedimentosRealizados.totalMedicamentos =
        numeral(totalMedicamentos).value()
      this.guia.procedimentosRealizados.totalDiarias =
        numeral(totalDiarias).value()
      this.guia.procedimentosRealizados.totalGases = numeral(totalGases).value()
      this.guia.procedimentosRealizados.totalGuia = numeral(totalGuia).value()

      const procedimentosSolicitacao = []
      const procedimentosRealizados = []
      let max = 0
      const maxAutorizadoEspecialiade = this.maxAgendamentosEspecialidade
      this.guia.solicitacao.procedimentos.forEach((proc) => {
        let qtdAutorizada = Number(proc.qtdAutorizada)
        if (qtdAutorizada > maxAutorizadoEspecialiade) {
          proc.qtdAutorizada = maxAutorizadoEspecialiade
          qtdAutorizada = maxAutorizadoEspecialiade
        }
        if (qtdAutorizada > max) {
          max = qtdAutorizada
        }
        if (!proc.vazio) {
          proc.data = moment().toISOString()
          proc.qtdRealizada = 0
          procedimentosSolicitacao.push(proc)
        }
        this.guia.procedimentosRealizados.maxAutorizado = max
      })

      this.guia.procedimentosRealizados.procedimentos.forEach((proc) => {
        if (!proc.vazio) {
          const data = proc.data
          const vu = proc.valorUnitario
          const vTotal = proc.valorTotal
          const vFixo = proc.valorFixo
          const reducaoAcrescimoPct = proc.reducaoAcrescimoPct
          proc.data = moment(data, 'DD/MM/YYYY').toISOString()
          proc.valorUnitario = numeral(vu).value()
          proc.valorTotal = numeral(vTotal).value()
          proc.valorFixo = numeral(vFixo).value()
          proc.reducaoAcrescimoPct = numeral(reducaoAcrescimoPct).value()
          procedimentosRealizados.push(proc)
        }
      })

      this.guia.solicitacao.procedimentos = procedimentosSolicitacao
      this.guia.procedimentosRealizados.procedimentos = procedimentosRealizados
    },
    posSalvar(result) {
      const dataAutorizacao = this.guia.autorizacao.dataAutorizacao
      const validadeSenha = this.guia.autorizacao.validadeSenha
      const dataEmissao = moment(this.guia.autorizacao.dataEmissao).format(
        'DD/MM/YYYY'
      )
      let validadeCarteira = ''

      if (this.guia.beneficiario.validadeCarteira) {
        validadeCarteira = moment(
          this.guia.beneficiario.validadeCarteira
        ).format('DD/MM/YYYY')
      }

      const dataSolicitacao = this.guia.solicitacao.data
      const totalProcedimentos =
        this.guia.procedimentosRealizados.totalProcedimentos
      const totalTaxasAlugueis =
        this.guia.procedimentosRealizados.totalTaxasAlugueis
      const totalMateriais = this.guia.procedimentosRealizados.totalMateriais
      const totalMedicamentos =
        this.guia.procedimentosRealizados.totalMedicamentos
      const totalDiarias = this.guia.procedimentosRealizados.totalDiarias
      const totalGases = this.guia.procedimentosRealizados.totalGases
      const totalGuia = this.guia.procedimentosRealizados.totalGuia

      this.guia.autorizacao.dataAutorizacao = dataAutorizacao
      this.guia.autorizacao.validadeSenha = validadeSenha
      this.guia.autorizacao.dataEmissao = dataEmissao
      this.guia.beneficiario.validadeCarteira = validadeCarteira
      this.guia.solicitacao.data = dataSolicitacao
      this.guia.procedimentosRealizados.totalProcedimentos = totalProcedimentos
      this.guia.procedimentosRealizados.totalTaxasAlugueis = totalTaxasAlugueis
      this.guia.procedimentosRealizados.totalMateriais = totalMateriais
      this.guia.procedimentosRealizados.totalMedicamentos = totalMedicamentos
      this.guia.procedimentosRealizados.totalDiarias = totalDiarias
      this.guia.procedimentosRealizados.totalGases = totalGases
      this.guia.procedimentosRealizados.totalGuia = totalGuia

      this.guia.solicitacao.procedimentos.forEach((proc) => {
        const data = proc.data
        proc.data = moment(data).format('DD/MM/YYYY')
      })

      const qtdSolic = this.guia.solicitacao.procedimentos.length

      for (let i = 5 - qtdSolic; i > 0; i--) {
        this.guia.solicitacao.procedimentos.push({
          data: '',
          codTabela: '',
          codigo: '',
          nome: '',
          valorFixo: '',
          qtdRealizada: '0',
          qtdSolicitada: '',
          qtdAutorizada: '',
          vazio: true,
        })
      }

      this.guia.procedimentosRealizados.procedimentos.forEach((p) => {
        if (p.data) {
          const data = p.data
          p.data = moment(data).format('DD/MM/YYYY')
        }

        const reducaoAcrescimoPct = numeral(p.reducaoAcrescimoPct)
        p.reducaoAcrescimoPct = reducaoAcrescimoPct.format('0,0.00')
        const valorUnitario = numeral(p.valorUnitario)
        p.valorUnitario = valorUnitario.format('0,0.00')
        const valorTotal = numeral(p.valorTotal)
        p.valorTotal = valorTotal.format('0,0.00')
        const valorFixo = numeral(p.valorFixo)
        p.valorFixo = valorFixo.format('0,0.00')
      })

      const qtdRealizada =
        this.guia.procedimentosRealizados.procedimentos.length

      for (let i = 5 - qtdRealizada; i > 0; i--) {
        this.guia.procedimentosRealizados.procedimentos.push({
          data: '',
          horaInicial: '',
          horaFinal: '',
          codigoTabela: '',
          codigo: '',
          nome: '',
          qtdRealizada: '',
          qtdSolicitada: 0,
          qtdAutorizada: 0,
          viaAcesso: '',
          tecnicaUtilizada: '',
          reducaoAcrescimoPct: '',
          valorUnitario: '',
          valorTotal: '',
          valorFixo: '',
          vazio: true,
        })
      }

      if (result && result.erro) {
        mensagemServico.alerta(result.erro.content, result.erro.title)
        return
      }

      if (result) {
        this.guia._id = result.guia._id
        this.guia.autorizacao.numeroGuia = result.guia.autorizacao.numeroGuia
      }
    },
    salvar() {
      this.preSalvar()
      this.v$.$touch()
      if (this.v$.guia.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
        this.visaoSimplificada = false
        this.posSalvar()
      } else if (this.guia._id) {
        this.historicoCadastro()
        guiaServico.atualizar(this.guia._id, this.guia).then((res) => {
          this.posSalvar(res)
        })
      } else {
        this.historicoCadastro()
        guiaServico.criar(this.guia).then((res) => {
          this.posSalvar(res)
        })
      }
    },
    historicoCadastro() {
      if (!this.guia.historico || !this.guia.historico.length) {
        this.guia.historico = []
      }

      this.guia.historico.push({
        codigo: 1,
        descricao: 'Criada / Atualizada',
        dataCriacao: new Date(),
        criadoPor: appStore.usuario.email,
      })
    },
    selecionarEspecialidade(event) {
      const especialidadeSelecionada = this.especialidades.filter(
        (especialidade) => especialidade.nome === event.target.value
      )
      this.maxAgendamentosEspecialidade =
        especialidadeSelecionada[0].maximoAgendamentos
    },
    retornarQuantidadeMaxAgendamentos(especialidadeGuia) {
      const especialidadeSelecionada = this.especialidades.filter(
        (especialidade) => especialidade.nome === especialidadeGuia
      )
      return especialidadeSelecionada[0].maximoAgendamentos
    },
  },
}
</script>
